import styled from 'styled-components'

const CommentContent = styled.div`
  font: var(--p2Regular);
  color: var(--white);
  * {
    overflow-wrap: break-word;
  }
  p {
    color: var(--white);
  }
  a {
    color: var(--turquoise);
    text-decoration: underline;
  }
  strong {
    color: var(--baseSecondary);
  }
  ul {
    padding-inline-start: 16px;
    & > li {
      position: relative;
      &::before {
        content: "";
        left: -16px;
        top: 8px;
        position: absolute;
        background: var(--turquoise);
        min-width: 8px;
        min-height: 8px;
        border-radius: 50%;
      }
    }
  }
  ol {
    list-style: none;
    padding-inline-start: 16px;
    counter-reset: order;
    & > li {
      counter-increment: order;
      position: relative;
      &::before {
        content: counter(order)".";
        left: -16px;
        position: absolute;
        color: var(--turquoise);
        min-width: 15px;
      }
    }
  }
  @media screen and (min-width: 1024px) {
    font: var(--regular);
  }
`

export default CommentContent
